import request from '@/utils/request2'

// 列表(主数据列表)
export function loadWeChatGroupMemberListDataApi(data) {
  return request({
    url: 'tms-web/weChatGroupMember/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportWeChatGroupMemberListDataApi(data) {
  return request({
    url: 'tms-web/weChatGroupMember/exportByPage',
    method: 'post',
    data
  })
}

// 认证零售户档案
export function connectStoreWeChatGroupMemberApi(data) {
  return request({
    url: 'tms-web/weChatGroupMember/connectStore',
    method: 'post',
    data
  })
}

// 关联小程序用户
export function connectAppUserWeChatGroupMemberApi(data) {
  return request({
    url: 'tms-web/weChatGroupMember/connectAppUser',
    method: 'post',
    data
  })
}

// 查看
export function viewWeChatGroupMemberApi(data) {
  return request({
    url: 'tms-web/weChatGroupMember/view',
    method: 'post',
    data
  })
}

// 列表
export function listWeChatGroupMemberApi(data) {
  return request({
    url: 'tms-web/weChatGroupMember/list',
    method: 'post',
    data
  })
}
